export const Unauthorized = () => {
  return <div>401 - Non autorizzato</div>;
};
export default Unauthorized;
